import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function CollapsibleDescription({ text }) {
    const [open, setOpen] = useState(false);
    return (
      <div className="mb-2 w-full flex flex-col items-center">
        <div
          className={`min-w-full text-sm text-gray-300 whitespace-break-spaces break-all bg-aw-bluegray/20 p-4 rounded-lg ${
            open
              ? "line-clamp-none max-h-[35dvh] scrollbar-box thin overflow-auto"
              : "line-clamp-2 min-h-[15dvh] max-h-[20dvh]"
          }`}
        >
          {text}
        </div>
        <button
          className="text-aw-green text-xs mx-auto mt-1"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? (
            <FontAwesomeIcon icon={"fa-solid fa-chevron-up"} className="mr-1" />
          ) : (
            <FontAwesomeIcon
              icon={"fa-solid fa-chevron-down"}
              className="mr-1"
            />
          )}
        </button>
      </div>
    );
  }